'use es6';

import { isMouseLikePointerType } from "../utils/event.js";
export { isTargetInsideEnabledTrigger as isInsideEnabledTrigger } from "../utils/element.js";
function resolveValue(value, pointerType) {
  if (pointerType != null && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'function') {
    return value();
  }
  return value;
}
export function getDelay(value, prop, pointerType) {
  const result = resolveValue(value, pointerType);
  if (typeof result === 'number') {
    return result;
  }
  return result === null || result === void 0 ? void 0 : result[prop];
}
export function getRestMs(value) {
  if (typeof value === 'function') {
    return value();
  }
  return value;
}
export function isClickLikeOpenEvent(openEventType, interactedInside) {
  return interactedInside || openEventType === 'click' || openEventType === 'mousedown';
}
export function isHoverOpenEvent(openEventType) {
  return (openEventType === null || openEventType === void 0 ? void 0 : openEventType.includes('mouse')) && openEventType !== 'mousedown';
}